import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

export async function list (filtros) {
  return httpAuth.get(`/acessorelatorio?${serialize(filtros)}`, { tela: 'acesso_relatorio' })
}

export async function get (id) {
  return httpAuth.get(`/acessorelatorio/${id}`)
}

export async function add (dados) {
  return httpAuth.post(`/acessorelatorio`, dados, { funcionalidade: 'acesso_relatorio_incluir' })
}

export async function duplicate (id) {
  return httpAuth.post(`/acessorelatorio/duplicate/${id}`, { funcionalidade: 'acesso_relatorio_duplicar' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/acessorelatorio/${id}`, dados, { funcionalidade: 'acesso_relatorio_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/acessorelatorio/${id}`, { funcionalidade: 'acesso_relatorio_excluir' })
}

export async function execute (url, params) {
  return httpAuth.get(`${url}?${serialize(params)}`)
}
